import * as React from 'react';
import { useCallback, useState } from 'react';
import { Box, Collapse, FormControlLabel, Paper, Stack, Switch, Typography } from '@mui/material';
import ContactForm, { ContactProps } from '../components/ContactForm';
import { Chat, PhoneEnabled } from '@mui/icons-material';
import AppBarPage from '../components/AppBarPage';
import { ModeLink } from '../components/ModeButton';

const HomePage = (): JSX.Element => {
    const [contact, setContact] = useState<ContactProps>({
        firstName: 'John',
        lastName: 'Doe',
        orgName: 'YouCare',
        serviceType: 'transitionOfCare'
    });
    const [expanded, setExpanded] = useState(false);
    const handleChange = useCallback((event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(!expanded);
    }, [expanded]);
    return (
        <AppBarPage title='Ziphy Assistant'>
            <Stack direction='column' spacing={2} sx={{ maxWidth: '480px', margin: '16px auto 0' }}>
                <ModeLink
                    to='chat' 
                    title='Chat' 
                    description='Chat with our AI bot'
                    icon={<Chat />} 
                    state={expanded ? contact : undefined}
                />
                <ModeLink
                    to={expanded ? 'outreach' : 'support'}
                    title='Voice' 
                    description='Talk with our AI bot by voice'
                    icon={<PhoneEnabled />}
                    state={expanded ? contact : undefined}
                />
            </Stack>
            <Paper
                elevation={4}
                sx={{
                    margin: (theme) => theme.spacing(2),
                    padding: (theme) => '0 ' + theme.spacing(2),
                }} >
                <FormControlLabel
                    control={<Switch checked={expanded} onChange={handleChange} />}
                    label='Emulate Outreach' labelPlacement='start'
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        height: '64px'
                    }} />
                <Collapse in={expanded} >
                    <Typography>
                        Emulates calling from a healthcare company to you.
                        Provide you name and phone to let us emulate we know what we are calling to.
                    </Typography>
                    <Box height={(theme) => theme.spacing(4)} />
                    <ContactForm contact={contact} onChange={setContact} />
                    <Box height={(theme) => theme.spacing(2)} />
                </Collapse>
            </Paper>
        </AppBarPage>
    )
}
export default HomePage;